// Display rules for product pricing:
// - both empty       → "" (the caller can choose to hide the line)
// - only priceDay    → "{priceDay}"
// - only price (W-E) → "{price}"
// - both filled      → "{priceDay}"  (day takes priority)
// Note: any "à partir de" prefix is now managed manually in the admin field
// (e.g. "à partir de 50€/J" or "Sur Devis"). The display is verbatim.
export function formatProductPrice(product) {
  const day = (product?.priceDay || '').toString().trim();
  const we = (product?.price || '').toString().trim();
  return day || we;
}
